module.exports = __webpack_public_path__ + "static/media/performance.8e322f70.svg";